import React from 'react'
import FormUser from '../../../../component/formUser/formUser'

function EditUser() {
  return (
    <FormUser />
  )
}

export default EditUser